"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Unit = void 0;
var gql = String.raw;
var create_entity_1 = require("../../utils/create-entity");
exports.Unit = {
  name: 'Unit',
  autoRoutes: ['create', 'update', 'list'],
  update: {
    queryFields: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      shorthand\n      valueType { id slug name }\n      prefix\n      suffix\n    "], ["\n      shorthand\n      valueType { id slug name }\n      prefix\n      suffix\n    "])))
  },
  table: {
    fieldNames: ["info", "shorthand", "valueType", "minValue", "maxValue"],
    fields: {
      info: {
        title: 'Info'
      },
      types: {
        title: 'Types'
      }
    }
  },
  list: {
    resultsVariant: 'table',
    queryFields: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      shorthand\n      valueType { id slug name }\n      prefix\n      suffix\n    "], ["\n      shorthand\n      valueType { id slug name }\n      prefix\n      suffix\n    "])))
  },
  form: {
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      shorthand: {
        type: "text",
        description: "Is there a shorthand form if this {{UNIT}}"
      },
      valueType: {
        type: "linked",
        description: "What scalar variable type do values of this unit represent? This is used by the platform to be able to understand how to process values under this unit.",
        entityTypeName: "ValueType"
      },
      minValue: {
        type: 'text',
        recommended: false,
        description: "For numeric units, what is the minimum value that can be recorded?"
      },
      maxValue: {
        type: 'text',
        recommended: false,
        description: "For numeric units, what is the maximum value that can be recorded?"
      },
      prefix: {
        type: 'text',
        description: 'When presenting a value using this unit, what prefix should be placed before the value?',
        recommended: true
      },
      suffix: {
        type: 'text',
        description: 'When presenting a value using this unit, what suffix should be placed after the value? Note: This MUST be specified to have the units show up after the value, for example when showing a unit of measure. Also, some units may not need legitimately need a suffix (e.g., simple counts etc).',
        recommended: true
      }
    })
  }
};
var templateObject_1, templateObject_2;